//setter 

export const saveName = ({commit},msg) => {
     commit('saveMsg', msg)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js